import LTR from "@brand-icons/global/calendar/calendar-ltr.svg";
import RTL from "@brand-icons/global/calendar/calendar-rtl.svg";

import { iconFactory } from "../iconFactory";

export const CalendarIcon = iconFactory("CalendarIcon", LTR, RTL);
